import { render, staticRenderFns } from "./ReadBook.vue?vue&type=template&id=2735ec24"
import script from "./ReadBook.vue?vue&type=script&lang=js"
export * from "./ReadBook.vue?vue&type=script&lang=js"
import style0 from "./ReadBook.vue?vue&type=style&index=0&id=2735ec24&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports